"use strict";
exports.__esModule = true;
exports.LocalStorageProductVariant = exports.LocalStorageProductType = exports.CreditReportingEventType = exports.EXCELLENT = exports.VERY_GOOD = exports.GOOD = exports.FAIR = exports.POOR = exports.CreditStatus = exports.ScoreChangeType = void 0;
// use these types until BE is completed
var ScoreChangeType;
(function (ScoreChangeType) {
    ScoreChangeType["INCREASE"] = "INCREASE";
    ScoreChangeType["DECREASE"] = "DECREASE";
    ScoreChangeType["NO_CHANGE"] = "NO_CHANGE";
})(ScoreChangeType = exports.ScoreChangeType || (exports.ScoreChangeType = {}));
var CreditStatus;
(function (CreditStatus) {
    CreditStatus["OK"] = "OK";
    CreditStatus["FROZEN"] = "FROZEN";
    CreditStatus["INSUFFICIENT_HISTORY"] = "INSUFFICIENT_HISTORY";
    CreditStatus["NO_MATCH"] = "NO_MATCH";
    CreditStatus["UNKNOWN"] = "UNKNOWN";
})(CreditStatus = exports.CreditStatus || (exports.CreditStatus = {}));
exports.POOR = 580;
exports.FAIR = 670;
exports.GOOD = 740;
exports.VERY_GOOD = 800;
exports.EXCELLENT = 850;
var CreditReportingEventType;
(function (CreditReportingEventType) {
    CreditReportingEventType["RENT_PAID"] = "RENT_PAID";
    CreditReportingEventType["CREDIT_LINE_USED"] = "CREDIT_LINE_USED";
})(CreditReportingEventType = exports.CreditReportingEventType || (exports.CreditReportingEventType = {}));
var LocalStorageProductType;
(function (LocalStorageProductType) {
    LocalStorageProductType["CREDIT_BUILDER"] = "credit-builder";
    LocalStorageProductType["RENT_SPLIT"] = "rent-split";
})(LocalStorageProductType = exports.LocalStorageProductType || (exports.LocalStorageProductType = {}));
var LocalStorageProductVariant;
(function (LocalStorageProductVariant) {
    LocalStorageProductVariant["CREDIT_BUILDER_CONTROL"] = "credit-builder-control";
    LocalStorageProductVariant["CREDIT_BUILDER_TREATMENT"] = "credit-builder-treatment";
})(LocalStorageProductVariant = exports.LocalStorageProductVariant || (exports.LocalStorageProductVariant = {}));
